<template>
    <section class="page-section" id="services">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 text-center">
          <h2 class="section-heading text-uppercase">Servicios</h2>
          <h3 class="section-subheading text-muted">Brindando servicios durante más de 10 años.</h3>
        </div>
      </div>
      <div class="row text-center">
        <div class="col-md-4">
          <span class="fa-stack fa-4x">
            <i class="fas fa-circle fa-stack-2x text-primary"></i>
            <i class="fas fa-shopping-cart fa-stack-1x fa-inverse"></i>
          </span>
          <h4 class="my-3">Sitios Web</h4>
          <p class="text-muted">Diseñando y desarrollando sitios web para su negocio. Brindando soluciones de negocio para cada modelo y contemplando la realidad de cada cliente.</p>
        </div>
        <div class="col-md-4">
          <span class="fa-stack fa-4x">
            <i class="fas fa-circle fa-stack-2x text-primary"></i>
            <i class="fas fa-laptop fa-stack-1x fa-inverse"></i>
          </span>
          <h4 class="my-3">Consultoría</h4>
          <p class="text-muted">Escuchando y guiando al cliente en las necesidades de su negocio, permitiendo sacar el máximo provecho de sus procesos de negocio.</p>
        </div>
        <div class="col-md-4">
          <span class="fa-stack fa-4x">
            <i class="fas fa-circle fa-stack-2x text-primary"></i>
            <i class="fas fa-lock fa-stack-1x fa-inverse"></i>
          </span>
          <h4 class="my-3">Generador de Código</h4>
          <p class="text-muted">Desarrollo ágil basado en metodologías modernas y con la posibilidad de contar con un generador de código que permite reducir los tiempos de desarrollo.</p>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
    name: 'services-component'
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/ServicesComponent/servicesComponent.vue